<div class="flex h-full items-center">
  <div class="flex space-x-xl">
    <bgo-navbar-logo></bgo-navbar-logo>
  </div>
</div>
